import { render } from "./home.vue?vue&type=template&id=07d9c3f9"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import exportComponent from "/Users/willson/Desktop/project/welove/admin_js/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__